module.exports = __webpack_public_path__ + "static/media/plane-alt.86e417ee.svg";